import * as React from "react"

import Panel from '../Panel';

import * as S from './styles';

export default function Steps() {
  return (
    <S.Container>
      <S.Content>
        <Panel step={1} />
        <Panel step={2} />
        <Panel step={3} />
      </S.Content>
    </S.Container>
  )
}